import styled, { css } from 'styled-components/macro'
import { Link } from 'react-router-dom'
import { Button } from '../../../commons/Button';
import Icon from '../../../commons/Icon';

export const CatalogProductCard = styled.div`${({ theme }) => css`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 0.5rem;
  min-height: 100%;
  width: 100%;
  max-width: 32rem;
  padding: 1.5rem 1.5rem 3rem;
  background: ${theme.colors.mono.white};
  box-shadow: ${theme.shadows.card};
  border-radius: 0.8rem;
`}`

export const ImageWrapper = styled.figure`
  display: flex;
  align-items: start;
  justify-content: center;
  position: relative;
  height: ${({ $isCategoryPage}) => $isCategoryPage ? '16rem' : '20rem'};
  img {
    max-width: 100%;
    max-height: 100%;
    border-radius: 0.8rem;
  }
`

export const Image = styled.img``;

export const Title = styled.h3`
  letter-spacing: 0.05rem;
  text-align: center;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SubTitle = styled.small`
  margin-top: 2rem;
  font-size: ${({ theme }) => theme.fontSize.xs};
  text-align: center;
`

export const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  justify-content: end;
  margin-top: auto;
`

export const PriceWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 1.5rem 0;
  margin-top: 0;
  font-weight: 700;
  line-height: 2.2rem;
  letter-spacing: -.03rem;
  color: ${({ theme }) => theme.colors.primary.default};
`

export const Price = styled.span`
  margin-left: 0.5rem;
  font-size: ${({ theme }) => theme.fontSize.xl};
  line-height: 3.8rem;
  letter-spacing: -0.1rem;
`

export const OriginalPriceWrapper = styled.div`
  display: flex;
  align-items: center;
  font-weight: 700;
  line-height: 2.2rem;
  letter-spacing: -.03rem;
  color: ${({ theme }) => theme.colors.primary.default};
`

export const OriginalPrice = styled.span`
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSize.md};
  letter-spacing: -0.1rem;
  text-decoration: line-through;
  color: ${({ theme }) => theme.colors.mono.greyDarker};
`

export const MoreDetails = styled(Link)`
  margin-top: 1.5rem;
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSize.md};
  line-height: 2.2rem;
  letter-spacing: -.03rem;
  color: ${({ theme }) => theme.colors.mono.greyDarker};

  &:hover {
    color: ${({ theme }) => theme.colors.mono.black};
  }
`

export const ProductCardLink = styled(Link)`
  display: table;
  margin: 1.5rem auto 0;
  font-weight: 800;
  font-size: ${({ theme }) => theme.fontSize.lg};
  line-height: 1.5rem;
  text-align: center;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.colors.primary.default};
  flex: 1;
  &:hover {
    color: ${({ theme }) => theme.colors.mono.black};
  }
  @media ${({ theme }) => theme.screens.md} {
    color: ${({ theme }) => theme.colors.mono.greyDarker};
  }
`

export const StepperWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`

export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.8rem;
  height: 2.8rem;
  margin-bottom: 1.5rem;
  color: ${({ theme }) => theme.colors.mono.greyDarker};
  &:hover {
    color: ${({ theme }) => theme.colors.primary.default};
  }
`

export const DeleteIcon = styled(Icon)`
  width: 1.8rem;
  height: 1.8rem;
`

export const BuyButton = styled(Button)`
  padding: 1rem 2rem;
`
